import script from "./ConsultancyForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsultancyForm.vue?vue&type=script&setup=true&lang=js"

import "./ConsultancyForm.vue?vue&type=style&index=0&id=72d31a8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72d31a8c"]])

export default __exports__